// extracted by mini-css-extract-plugin
export default {"root":"picture-link_root__dkJoP","logo":"picture-link_logo__MKLpT"};